import { ButtonType, ButtonWidget } from '@tableau/widgets';
import React from 'react';

import { Location} from '~commonInfra/utils/Location';
import { SessionUserSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { siteUrlsSelector } from '~src/bootstrap/redux/selectors/SiteUrlsSelectors';
import { getAppStore } from '~src/bootstrap/redux/store/AppStore';
import { Messages } from '~src/codegen/Localize';
import { HelpService } from '~src/commonInfra/services/HelpService';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';
import { WebHttpClientWithErrorToastInstance } from '~src/httpClient/WebHttpClientWithErrorToast';
import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';
import { UpdateDataManagementAwarenessRequest } from '~src/userSettings/serverApi/requests/UpdateDataManagementAwarenessRequest';

import {   getListWrapper,labelManagementBody,
labelManagementButtonWrapper,
  labelManagementHeader,
  labelManagementImageContent,
  labelManagementTextContent,
  labelManagementWrapper } from './DMAwarenessStyles';
import { showDisableDataManagementAwarenessToast } from './DmAwarenessUtils';


export function DataLabelsPreviewDialog(): JSX.Element {
  const siteUrls = siteUrlsSelector(getAppStore().getState());
  const currentUser = getSessionManagementServiceInstance().sessionUserInfo();
  const url = siteUrls.userSettingsUrl(currentUser.username, currentUser.domainName);

  const onLearnMore = () => {
    window.open(HelpService.getHelpUrlByCategory('server-dmaware-dqw-cloud'), '_blank');
  };

  const onDismiss = () => {
    WebHttpClientWithErrorToastInstance.sendRequestAndDelay(
      new UpdateDataManagementAwarenessRequest({
        user:currentUser.id,
        prepConductorAwarenessEnabled:SessionUserSelectors.showPrepConductorAwareness(getAppStore().getState()),
        catalogAwarenessEnabled: false
      })).then(() => {
        getSessionManagementServiceInstance().refreshSessionInfo();
      });
    Location.instance.setUrl(siteUrls.statusUrl());
    showDisableDataManagementAwarenessToast(url);
  };

  return (
    <div className={labelManagementWrapper}>
    <div className={labelManagementImageContent}>
      <img width={800} height={450} alt={Messages.dataLabelsPreviewInformationHeader()} src={imgPath('label_management_preview_1600x900.gif')}/>
    </div>
    <div className={labelManagementTextContent}>
      <div className={labelManagementHeader}>{Messages.dataLabelsPreviewInformationHeader()}</div>
      <div className={labelManagementBody}>{Messages.dataLabelsPreviewInformationBody()}</div>
      <ul className={getListWrapper()}>
          <li>{Messages.dataLabelsPreviewInformationListItem1()}</li>
          <li>{Messages.dataLabelsPreviewInformationListItem2()}</li>
          <li>{Messages.dataLabelsPreviewInformationListItem3()}</li>
          <li>{Messages.dataLabelsPreviewInformationListItem4()}</li>
          <li>{Messages.dataLabelsPreviewInformationListItem5()}</li>
          <li>{Messages.dataLabelsPreviewInformationListItem6()}</li>
      </ul>
      <div className={labelManagementButtonWrapper}>
        <ButtonWidget onClick={onLearnMore} buttonType={ButtonType.Primary}>{Messages.learnMore()}</ButtonWidget>
        <ButtonWidget onClick={onDismiss} buttonType={ButtonType.LowEmphasis}>{Messages.dmAwarenessPreviewNoThanksButtonText()}</ButtonWidget>
      </div>
    </div>
  </div>

  );
}
